import { render, staticRenderFns } from "./NewEmojiUploader.vue?vue&type=template&id=403a380a&"
import script from "./NewEmojiUploader.vue?vue&type=script&lang=js&"
export * from "./NewEmojiUploader.vue?vue&type=script&lang=js&"
import style0 from "./NewEmojiUploader.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewEmojiUploader.vue"
export default component.exports